// Heeral — comportamento da PDP clonada (shadow root de <cf-pdp>): variantes, galeria, quantidade,
// add to cart (gaveta do Horizon), bundle, "Complete The Look", avaliações (ordenar/filtrar/mostrar mais).
const money = (c) => {
  const v = c / 100;
  return '$' + (Number.isInteger(v) ? v.toString() : v.toFixed(2));
};

async function addToCart(host, items) {
  // Mesmo fluxo do product-form do Horizon: dispara CartLinesUpdateEvent e devolve as seções do carrinho.
  let Ev = null;
  try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (e) {}
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const deferred = Ev ? Ev.createPromise() : null;
  if (Ev) {
    host.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: deferred.promise }));
  }
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: ids.join(','), sections_url: location.pathname }) });
    const j = await r.json();
    const cart = await (await fetch('/cart.js')).json();
    if (deferred) deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: host.id, itemCount: items.reduce((a, i) => a + i.quantity, 0), productId: host.dataset.pid, sections: j.sections, didError: !!j.status } });
    if (j.status) { alert(j.description || j.message); return false; }
    if (!ids.length) { location.href = '/cart'; return true; }
    setTimeout(() => { const d = document.querySelector('cart-drawer-component'); const td = d && d.closest('theme-drawer'); if (td && td.open && !td.isOpen) td.open(); }, 400);
    return true;
  } catch (e) { if (deferred) deferred.reject(e); return false; }
}

const SEL_C = ['colorOptionSelected__21ead010', '__bite_theme_productHeroOptions_colorOptionSelected'];
const SEL_S = ['sizeOptionSelected__21ead010', '__bite_theme_sizeOptionSelected'];

class CfPdp extends HTMLElement {
  connectedCallback() {
    if (this._init) return; this._init = true;
    if (!this.shadowRoot) { const t = this.querySelector('template[shadowrootmode]'); if (t) { this.attachShadow({ mode: 'open' }).appendChild(t.content); t.remove(); } }
    const R = (this.R = this.shadowRoot);
    const data = JSON.parse(this.querySelector('[data-cfvariants]').textContent);
    this.V = data.v; this.pct = data.pct; this.opts = data.opts;
    const vid = +R.querySelector('[data-vid]').value;
    this.cur = (this.V.find((x) => x.id === vid) || this.V[0]).o.slice();
    this.cpos = this.opts.indexOf('Color');
    this.qty = 1;
    this.bindOptions(); this.bindQty(); this.bindAtc(); this.bindBundle(); this.bindCtl(); this.bindMisc(); this.bindReviews(); this.bindSlider(); this.bindCards();
  }
  variant(o) { return this.V.find((x) => x.o.every((v, i) => v === o[i])) || this.V.find((x) => x.o[this.cpos] === o[this.cpos]); }
  bindOptions() {
    const R = this.R;
    R.querySelectorAll('.container__21ead010 a[data-opt]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      const pos = +a.dataset.opt - 1; this.cur[pos] = a.dataset.val;
      let v = this.variant(this.cur); if (v) this.cur = v.o.slice();
      this.render();
    }));
  }
  render() {
    const R = this.R, v = this.variant(this.cur); if (!v) return;
    // seleção
    R.querySelectorAll('.container__21ead010 a[data-opt]').forEach((a) => {
      const on = this.cur[+a.dataset.opt - 1] === a.dataset.val; const sp = a.firstElementChild;
      const cls = sp.classList.contains('colorOption__21ead010') ? SEL_C : SEL_S;
      cls.forEach((c) => sp.classList.toggle(c, on)); if (on) sp.setAttribute('data-selected', ''); else sp.removeAttribute('data-selected');
      const inp = a.nextElementSibling; if (inp) inp.checked = on;
    });
    R.querySelectorAll('[data-glabel]').forEach((l) => {
      const g = l.dataset.glabel; const fs = l.closest('fieldset');
      const inG = this.cpos >= 0 && [...fs.querySelectorAll('a[data-val]')].some((a) => a.dataset.val === this.cur[this.cpos]);
      l.textContent = g + ':' + (inG ? ' ' + this.cur[this.cpos] : '');
    });
    R.querySelectorAll('[data-olabel]').forEach((l) => { l.textContent = l.dataset.oname + ': ' + this.cur[+l.dataset.olabel - 1]; });
    // preço
    R.querySelector('[data-price]').textContent = money(v.p);
    const cmp = R.querySelector('[data-cmp]'); if (cmp) cmp.textContent = money(v.c);
    R.querySelector('[data-atcprice]').textContent = money(v.p);
    const ac = R.querySelector('[data-atccmp]'); if (ac) ac.textContent = money(v.c);
    R.querySelector('[data-vid]').value = v.id;
    R.querySelector('[data-atc]').disabled = !v.a;
    // galeria por cor
    if (this.cpos >= 0) {
      const col = this.cur[this.cpos];
      R.querySelectorAll('[data-gal] a[data-alt]').forEach((a) => { a.hidden = !(a.dataset.alt === col || a.dataset.alt === 'all'); });
      R.querySelectorAll('[data-gal]').forEach((g) => { g.scrollLeft = 0; });
    }
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
  }
  bindQty() {
    const R = this.R, inp = R.querySelector('[data-qty]'), minus = R.querySelector('[data-qminus]'), plus = R.querySelector('[data-qplus]'), sr = R.querySelector('[data-qsr]');
    const set = (n) => { this.qty = Math.max(1, Math.min(10, n)); inp.value = this.qty; minus.disabled = this.qty <= 1; plus.disabled = this.qty >= 10; sr.textContent = 'Quantity ' + this.qty; };
    minus.addEventListener('click', () => set(this.qty - 1)); plus.addEventListener('click', () => set(this.qty + 1));
  }
  bindAtc() {
    const R = this.R, f = R.querySelector('[data-atcform]');
    f.addEventListener('submit', async (e) => {
      e.preventDefault(); const b = f.querySelector('button'); b.disabled = true;
      await addToCart(this, [{ id: +f.querySelector('[data-vid]').value, quantity: this.qty }]);
      b.disabled = false;
    });
  }
  bindBundle() {
    const R = this.R, box = R.querySelector('[data-bundle]'); if (!box) return;
    const cards = [...box.querySelectorAll('[data-bcard]')];
    this.bsel = cards.map(() => this.cur.slice());
    const upd = () => {
      let full = 0, cmp = 0, tot = 0;
      cards.forEach((c, k) => {
        const v = this.variant(this.bsel[k]); if (!v) return; this.bsel[k] = v.o.slice();
        full += v.p; cmp += v.c || v.p; tot += v.p - Math.floor((v.p * this.pct) / 100);
        c.querySelectorAll('[data-bpos]').forEach((rg) => {
          const pos = +rg.dataset.bpos - 1;
          rg.querySelectorAll('[data-swatch-cell]').forEach((cell) => {
            const a = cell.querySelector('a'), on = a.dataset.val === this.bsel[k][pos];
            cell.querySelectorAll('span[data-opt-name]').forEach((sp) => {
              const isC = sp.dataset.optName === 'Color';
              (isC ? ['QMl69tAx', '__bite_theme_productHeroOptions_colorOptionSelected'] : ['UXdMckXt', '__bite_theme_sizeOptionSelected']).forEach((x) => sp.classList.toggle(x, on));
              if (on) sp.setAttribute('data-selected', ''); else sp.removeAttribute('data-selected');
            });
            if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
            const inp = cell.querySelector('input'); if (inp) inp.checked = on;
          });
        });
        c.querySelectorAll('[data-blabel]').forEach((l) => { l.textContent = l.dataset.oname + ': ' + this.bsel[k][+l.dataset.blabel - 1]; });
        c.querySelectorAll('[data-bsel]').forEach((s) => { s.value = this.bsel[k][+s.dataset.bsel - 1]; });
        const im = c.querySelector('[data-bimg]'); if (im && v.img) im.src = v.img;
        const bp = c.querySelector('[data-bcprice]'); if (bp) bp.textContent = money(v.p);
        const bc = c.querySelector('[data-bccmp]'); if (bc) bc.textContent = money(v.c || v.p);
      });
      R.querySelector('[data-bcmp]').textContent = money(cmp); R.querySelector('[data-bfull]').textContent = money(full);
      R.querySelector('[data-btotal]').textContent = money(tot); R.querySelector('[data-bbtncmp]').textContent = money(cmp); R.querySelector('[data-bbtntotal]').textContent = money(tot);
    };
    cards.forEach((c, k) => {
      c.querySelectorAll('[data-bpos]').forEach((rg) => rg.querySelectorAll('[data-swatch-cell]').forEach((cell) => {
        const pick = (e) => { e.preventDefault(); this.bsel[k][+rg.dataset.bpos - 1] = cell.querySelector('a').dataset.val; upd(); };
        cell.querySelector('a').addEventListener('click', pick); cell.querySelector('label').addEventListener('click', pick);
      }));
      c.querySelectorAll('[data-bsel]').forEach((s) => s.addEventListener('change', () => { this.bsel[k][+s.dataset.bsel - 1] = s.value; upd(); }));
    });
    upd();
    box.querySelector('[data-bform]').addEventListener('submit', async (e) => {
      e.preventDefault(); const b = e.target.querySelector('button'); b.disabled = true;
      const ids = this.bsel.map((o) => this.variant(o).id); const items = [];
      ids.forEach((id) => { const it = items.find((x) => x.id === id); if (it) it.quantity++; else items.push({ id, quantity: 1 }); });
      await addToCart(this, items); b.disabled = false;
    });
  }
  bindCtl() {
    this.R.querySelectorAll('[data-ctl]').forEach((card) => {
      const V = JSON.parse(card.querySelector('[data-ctlvariants]').textContent);
      const form = card.querySelector('[data-ctlform]'); const idI = form.querySelector('[name=id]');
      let cur = (V.find((x) => x.id === +idI.value) || V[0]).o.slice();
      const upd = () => {
        const v = V.find((x) => x.o.every((a, i) => a === cur[i])) || V.find((x) => x.o[0] === cur[0]); if (!v) return; cur = v.o.slice();
        idI.value = v.id; card.querySelector('[data-ctlprice]').textContent = v.p.replace(/\.00$/, '');
        card.querySelectorAll('a[data-pos]').forEach((a) => {
          const on = cur[+a.dataset.pos - 1] === a.dataset.val, sp = a.firstElementChild;
          sp.classList.toggle(sp.classList.contains('colorOption__62245f8e') ? 'colorOptionSelected__62245f8e' : 'sizeOptionSelected__62245f8e', on);
        });
        card.querySelectorAll('fieldset').forEach((fs, i) => { const l = fs.querySelector('.label__62245f8e'); if (l) l.textContent = l.dataset.lbl + ': ' + cur[i]; });
        const im = card.querySelector('.image__62245f8e'); if (im && v.img) im.src = v.img;
        form.querySelector('button').disabled = !v.a;
      };
      card.querySelectorAll('a[data-pos]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); cur[+a.dataset.pos - 1] = a.dataset.val; upd(); }));
      form.addEventListener('submit', async (e) => { e.preventDefault(); await addToCart(this, [{ id: +idI.value, quantity: 1 }]); });
    });
  }
  bindMisc() {
    const R = this.R;
    const dlg = R.querySelector('[data-cvdlg]');
    if (dlg) { R.querySelector('[data-cvbtn]').addEventListener('click', (e) => { e.preventDefault(); dlg.showModal(); }); R.querySelector('[data-cvclose]').addEventListener('click', () => dlg.close()); dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); }); }
    R.querySelectorAll('[data-wish]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); }));
    R.querySelectorAll('[data-toreviews], a[href="#reviews"]').forEach((a) => a.addEventListener('click', (e) => { const t = R.getElementById('reviews'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); } }));
    // lightbox simples para a galeria e fotos das avaliações
    const open = (src) => { const d = document.createElement('dialog'); d.style.cssText = 'padding:0;border:0;max-width:96vw;max-height:96vh;background:transparent'; d.innerHTML = `<img src="${src}" style="max-width:96vw;max-height:92vh;display:block">`; d.addEventListener('click', () => { d.close(); d.remove(); }); R.appendChild(d); d.showModal(); };
    R.querySelectorAll('[data-gal] a').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); open(a.href); }));
    R.querySelectorAll('[data-zoom]').forEach((b) => b.addEventListener('click', () => open(b.dataset.zoom + '&width=1600')));
  }
  bindReviews() {
    const R = this.R, grid = R.querySelector('[data-grid]'); if (!grid) return;
    const wrap = R.querySelector('[data-okesize]'); const items = [...grid.children];
    let shown = 6, filter = 0, order = 'featured';
    const layout = () => {
      const w = wrap.getBoundingClientRect().width;
      const size = w >= 1000 ? 'large' : w >= 600 ? 'medium' : 'small';
      wrap.classList.remove('oke-is-large', 'oke-is-medium', 'oke-is-small'); wrap.classList.add('oke-is-' + size);
      grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(' + (size === 'large' ? '32.5521%' : size === 'medium' ? '49%' : '100%') + ', 1fr))';
      items.forEach((li) => { if (li.hidden) return; const c = li.firstElementChild; li.style.gridRowEnd = 'span ' + Math.ceil(c.getBoundingClientRect().height + 10); li.style.opacity = 1; });
    };
    const apply = () => {
      const list = items.filter((li) => !filter || +li.dataset.r === filter);
      const key = { 'rating desc': (a) => -a.dataset.r, 'rating asc': (a) => +a.dataset.r, 'date desc': (a) => -a.dataset.d, 'date asc': (a) => +a.dataset.d, 'helpful desc': (a) => -a.dataset.h, 'helpful asc': (a) => +a.dataset.h, 'media desc': (a) => -a.dataset.m, featured: (a) => +a.dataset.i }[order];
      list.sort((a, b) => key(a) - key(b) || a.dataset.i - b.dataset.i);
      items.forEach((li) => { li.hidden = true; }); list.forEach((li, i) => { grid.appendChild(li); li.hidden = i >= shown; });
      const sm = R.querySelector('[data-showmore]'); if (sm) sm.closest('.oke-w-reviews-footer').hidden = list.length <= shown;
      requestAnimationFrame(layout);
    };
    // "Read More" do corpo (2 linhas como na origem)
    items.forEach((li) => {
      const body = li.querySelector('[data-body]'), btn = li.querySelector('[data-more]'), cont = li.querySelector('.oke-reviewContent');
      requestAnimationFrame(() => { if (body.scrollHeight > 44) { body.style.height = '40px'; btn.hidden = false; } else { cont.classList.remove('oke-is-truncated'); } layout(); });
      btn.addEventListener('click', () => { cont.classList.remove('oke-is-truncated'); body.style.height = ''; btn.hidden = true; layout(); });
    });
    const sum = R.querySelector('[data-sum]'), sm2 = R.querySelector('[data-summore]');
    if (sum && sm2) { const chk = () => { if (wrap.classList.contains('oke-is-small') && !sum.dataset.open) { sum.classList.add('oke-is-truncated'); sum.style.cssText = 'height: 68px; -webkit-line-clamp: 3;'; sm2.hidden = false; } else if (!sum.dataset.open) { sum.classList.remove('oke-is-truncated'); sum.style.cssText = ''; sm2.hidden = true; } }; requestAnimationFrame(chk); addEventListener('resize', chk); sm2.addEventListener('click', () => { sum.dataset.open = 1; sum.classList.remove('oke-is-truncated'); sum.style.cssText = ''; sm2.hidden = true; }); }
    R.querySelector('[data-showmore]')?.addEventListener('click', (e) => { e.preventDefault(); shown += 6; apply(); });
    R.querySelector('[data-sort]')?.addEventListener('change', (e) => { order = e.target.value; shown = 6; apply(); });
    R.querySelectorAll('[data-filter]').forEach((b) => b.addEventListener('click', () => { const f = +b.dataset.filter; filter = filter === f ? 0 : f; shown = 6; apply(); }));
    new ResizeObserver(() => layout()).observe(wrap);
    R.querySelectorAll('img').forEach((im) => im.complete || im.addEventListener('load', () => layout(), { once: true }));
    apply();
  }
  bindSlider() {
    const R = this.R, sl = R.querySelector('[data-bslider]'); if (!sl) return;
    const dots = [...R.querySelectorAll('[data-dot]')];
    const cards = [...sl.querySelectorAll('.box__e5f2ff3d')];
    sl.addEventListener('scroll', () => { const i = Math.round(sl.scrollLeft / ((cards[1]?.offsetLeft || 1) - (cards[0]?.offsetLeft || 0))); dots.forEach((d, k) => d.classList.toggle('dotActive__c6f07501', k === Math.min(i, dots.length - 1))); }, { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => sl.scrollTo({ left: cards[k].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' })));
  }
  bindCards() {
    this.R.querySelectorAll('.box__e5f2ff3d [data-cimg]').forEach((sp) => sp.addEventListener('click', () => {
      const box = sp.closest('.box__e5f2ff3d'); const im = box.querySelector('.heroImage__e5f2ff3d'); if (im) { im.src = sp.dataset.cimg; im.removeAttribute('srcset'); }
      box.querySelectorAll('.colorOption__e5f2ff3d').forEach((x) => x.classList.toggle('colorOptionSelected__e5f2ff3d', x === sp));
    }));
  }
}
if (!customElements.get('cf-pdp')) customElements.define('cf-pdp', CfPdp);
